import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { AuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { Estate } from "../../../models/Estate";
import { Typography } from "@mui/material";

export enum Outcomes {
  testamentary = "Letters of testamentary",
  administration = "Letters of administration",
  neither = "Neither",
}

export const LetterScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, setActiveEstate } = useContext(AuthContext);
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (letters: string): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    // const estate = activeEstate ? Estate.from(activeEstate) : new Estate();
    const estate = activeEstate || new Estate();
    estate.letters = letters;

    try {
      await estate.saveEstate();
      setActiveEstate && setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, letters, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="Have you or someone else submitted a request for or received either of the two following forms?"
      subTitle={
        <Typography>
          Executors submit for{" "}
          <a
            href="https://www.weareatticus.com/terms/letters-testamentary"
            target="_blank"
          >
            Letters Testamentary
          </a>{" "}
          if they are named executor of an estate in a will. They submit for{" "}
          <a
            href="https://www.weareatticus.com/terms/what-are-letters-of-administration"
            target="_blank"
          >
            Letters of Administration
          </a>{" "}
          if there was no will.
        </Typography>
      }
    >
      <RadioAndResponseForm
        initAnswer={activeEstate?.letters}
        answerLabel="Letters"
        errorText="Please select an option to continue"
        options={[
          {
            value: Outcomes.testamentary,
            help: {
              href: "https://www.weareatticus.com/terms/letters-testamentary",
            },
          },
          {
            value: Outcomes.administration,
            help: {
              href: "https://www.weareatticus.com/terms/what-are-letters-of-administration",
            },
          },
          { value: Outcomes.neither },
        ]}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
